export default "__VITE_ASSET__CsSJqeDv__"